import { type OpenApiSchemaImage, type OpenApiSchemaMediaItemV2, type OpenApiSchemaVideo } from '../../../api/schema';
import { mapFileMetadataToMediaMetadata } from './mediaMetadata';

export const mapMediaItemV2ToMediaV2Field = (mediaItem: OpenApiSchemaMediaItemV2) => {
    if (mediaItem.type === 'VIDEO') {
        const payload = mediaItem.payload as OpenApiSchemaVideo;

        return {
            id: payload.id,
            display_sequence: mediaItem.display_sequence,
            file_id: payload.id,
            file_path: payload.content?.first_frame_url || '',
            type: 'VIDEO' as const,
            sizes: [],
            video_id: payload.id,
            status: payload.status ?? 'processing',
            first_frame_url: payload.content?.first_frame_url || '',
            stream_dash_url: payload.content?.stream_dash_url || '',
            stream_hls_url: payload.content?.stream_hls_url || '',
            title: payload.title || '',
        };
    }

    const payload = mediaItem.payload as OpenApiSchemaImage;

    const type = mediaItem.type === 'IMAGE' || mediaItem.type === 'OTHER' ? mediaItem.type : 'IMAGE';

    return {
        id: payload.file_id,
        display_sequence: mediaItem.display_sequence,
        file_id: payload.file_id,
        file_path: payload.file_path,
        type,
        sizes: (payload.sizes || []).map((size) => {
            return {
                alias: size.alias,
                width: size.width || 0,
            };
        }),
        metadata: mapFileMetadataToMediaMetadata(payload.file_metadata),
        video_id: '',
        status: 'ready',
        first_frame_url: '',
        stream_dash_url: '',
        stream_hls_url: '',
        title: '',
    };
};
